import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  getTextPadding,
  getScaledFont,
  getMigratedStyleProps,
  isSupportSpExperimentOn,
} from '@wix/editor-elements-common-utils';
import type { ComboBoxInputDefinition } from '../../ComboBoxInput/ComboBoxInput.types';
import type { IComboBoxInputListModalCSSVars } from '../ComboBoxInputListModal.types';
import { migratedFields } from '../constants';

const justifyContent = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
} as const;

export const css = withCompInfo<
  IComboBoxInputListModalCSSVars,
  ComboBoxInputDefinition,
  {}
>()(
  [
    'compProps',
    'styleProperties',
    'compLayout',
    'hasResponsiveLayout',
    'isMobileView',
    'siteFonts',
    'formatCssValue',
    'experiments',
  ],
  ({
    compProps,
    styleProperties,
    compLayout,
    hasResponsiveLayout,
    isMobileView,
    siteFonts,
    formatCssValue,
    experiments,
  }) => {
    const { spx } = styleProperties;
    const compInfo = { compLayout, styleProperties, siteFonts, isMobileView };

    const { inputMobileFontSize } = compProps;

    const isSupportSpOn = isSupportSpExperimentOn(experiments);

    const migratedStyleProps = isSupportSpOn
      ? getMigratedStyleProps({
          compProps,
          styleProperties,
          migratedFields,
        })
      : compProps;

    const { dropdownItemsSpacing, textPadding, textAlignment } =
      migratedStyleProps as {
        dropdownItemsSpacing: string;
        textPadding: number;
        textAlignment: string;
      };
    const dropdownOptionJustifyContent =
      justifyContent[(textAlignment as keyof typeof justifyContent) || 'left'];

    const dropdownItemsSpacingValue = dropdownItemsSpacing ?? 16;
    return {
      height: '100%',
      '--fnt': getScaledFont(compInfo, 'fnt', inputMobileFontSize),
      '--dropdownItemsSpacing': isSupportSpOn
        ? formatCssValue(dropdownItemsSpacingValue, spx)
        : `${dropdownItemsSpacingValue}px`,
      '--dropdownOptionJustifyContent': dropdownOptionJustifyContent,
      '--dir': textAlignment === 'right' ? 'rtl' : 'ltr',
      '--textAlign': textAlignment!,
      '--textPadding': getTextPadding(
        {
          textAlignment,
          textPadding,
        },
        isSupportSpOn ? formatCssValue : undefined,
        spx,
      ),
      ...(!hasResponsiveLayout && { width: 'initial' }),
    };
  },
);

export default createComponentMapperModel({ css });
